<template>
<div>
    <Box @close="cerrar(false)">
        <template #top>Registrar Empleado</template>
        <template #center>
            <div class="nj-cols">
                <div class="nj-card">
                    <div class="nj-cols form c3">
                        <div>
                            <div class="nj-label">Nombre</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_nombre" ref="emp_nombre">
                        </div>
                        <div>
                            <div class="nj-label">Apellido</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_apellido">
                        </div>
                        <div>
                            <div class="nj-label">DNI</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_dni">
                        </div>
                        <div>
                            <div class="nj-label">Celular</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_celular">
                        </div>
                        <div>
                            <div class="nj-label">Correo electrónico</div>
                            <input type="text" class="nj-text" v-model="empleado.emp_email">
                        </div>
                        <div>
                            <div class="nj-label">Proyecto</div>
                            <select class="nj-select" v-model="empleado.pry_id">
                                <option></option>
                                <option v-for="item in proyectos" :key="item.pry_id" :value="item.pry_id">{{ item.pry_nombre }}</option>
                            </select>
                        </div>
                        <div>
                            <div class="nj-label">Puesto</div>
                            <select class="nj-select" v-model="empleado.pue_id">
                                <option></option>
                                <option v-for="item in puestos" :key="item.pue_id" :value="item.pue_id">{{ item.pue_nombre }}</option>
                            </select>
                        </div>
                        <div style="align-self: flex-end;">
                            <div class="nj-label">&nbsp;</div>
                            <div class="nj-check">
                                <input type="checkbox" id="isUsuario" v-model="empleado.genera_usuario" @change="reiniciar()">
                                <label for="isUsuario">Crear cuenta de usuario</label>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="empleado.genera_usuario">
                    <div class="nj-card">
                        <h1 class="subtitle">Datos de usuario</h1>
                        <div class="nj-cols form c3">
                            <div>
                                <div class="nj-label">Tipo</div>
                                <select class="nj-select" v-model="empleado.usuario.tiu_id">
                                    <option v-for="item in tipos_usaurio" :key="item.tiu_id" :value="item.tiu_id">{{ item.tiu_nombre }}</option>
                                </select>
                            </div>
                            <div>
                                <div class="nj-label">Usuario</div>
                                <input type="text" class="nj-text" v-model="empleado.usuario.usu_correo" ref="emp_nombre">
                            </div>
                            <div>
                                <div class="nj-label">Password</div>
                                <input type="password" class="nj-text" v-model="empleado.usuario.usu_password">
                            </div>
                            <div>
                                <div class="nj-label">Nivel</div>
                                <select class="nj-select" v-model="empleado.usuario.usu_nivel">
                                    <option v-for="item in lista_usuario_nivel" :key="item.niu_id" :value="item.niu_id">{{ item.niu_nombre }}</option>
                                </select>
                            </div>
                            <div>
                                <div class="nj-label">Roles</div>
                                <select class="nj-select" multiple v-model="id_roles">
                                    <option v-for="item in roles" :key="item.rol_id" :value="item.rol_id">{{ item.rol_nombre }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template #bottom>
            <button class="nj-button c-green" @click="registrar()"><i class="mdi mdi-content-save"></i>Registrar</button>
        </template>
    </Box>
</div>
</template>

<script>
import PuestoService from "../../services/PuestoService"
import RolService from "../../services/RolService"
import Toast from "../../util/toast"
import { Box } from "../components"
import { AppService, EmpleadoService, ResponseStatus, ProyectoService } from "../../rest"
import TipoUsuario from "../../constants/tipoUsuario"
import { Tools } from "../../util"

export default {
    name: "EmpleadoNew",
    components: {
        Box
    },
    data() {
        return {
            empleado: {
                emp_nombre: null,
                emp_apellido: null,
                emp_dni: null,
                emp_celular: null,
                emp_email: null,
                pue_id: null,
                genera_usuario: false,
                pry_id: null,
                usuario: {
                    usu_correo: null,
                    usu_password: null,
                    usu_nivel: null,
                    lista_usuario_rol: []
                },
            },
            roles: [],
            puestos: [],
            lista_usuario_nivel: [],
            id_roles: [],
            proyectos: [],
            tipos_usaurio: [],
        }
    },
    //
    methods: {
        registrar() {
            Tools.validate(
                [
                    this.empleado.emp_nombre,
                    this.empleado.emp_apellido,
                    this.empleado.emp_dni,
                    this.empleado.pue_id,
                ]
                , "Falta ingresar datos para registrar al empleado"
            )
            if (this.empleado.genera_usuario) {
                Tools.validate(
                    [
                        this.empleado.usuario.usu_correo,
                        this.empleado.usuario.usu_password,
                        this.id_roles.length,
                    ]
                    , "Falta ingresar datos para registrar al usuario"
                )
                // capturando los roles para el registro
                this.id_roles.forEach(item => {
                    this.empleado.usuario.lista_usuario_rol.push({
                        rol_id: item
                    })
                })
            }
            EmpleadoService.registrar(this.empleado).then(
                response => {
                    Toast.success(response.message)
                    this.cerrar(true)
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        reiniciar() {
            if (!this.empleado.genera_usuario) {
                this.empleado.usu_correo = null
                this.empleado.usu_password = null
                this.empleado.usuario.lista_usuario_rol = []
                this.id_roles = []
            }
        },
        cerrar(condition) {
            this.$emit("close", condition)
        }
    },
    //
    mounted() {
        this.$refs.emp_nombre.focus()
        // cargando los roles
        RolService.buscar().then(
            response => {
                this.roles = response.data
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
        // cargando los puestos
        PuestoService.buscar({
            pue_estado: 1
        }).then(
            response => {
                this.puestos = response.data
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
        // cargando proyectos (activos)
        ProyectoService.buscar({
            pry_estado: 1
        }).then(
            response => {
                this.proyectos = response.data
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
        // cargando niveles
        AppService.getData(["niveles_usuario"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.lista_usuario_nivel = response.data.niveles_usuario
                    this.empleado.usuario.usu_nivel = 0
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
        // cargando los tipos de usuario
        this.tipos_usaurio.push(TipoUsuario.data.EMPLEADO)
        this.empleado.usuario.tiu_id = 1
    }
}
</script>

<style scoped></style>